<h2 mat-dialog-title>{{ (data.lineItem ? "job_upgrade_edit_expense" : "job_upgrade_add_expense") | translate }}</h2>
<mat-dialog-content [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>{{ "job_upgrade_expense_type" | translate }}</mat-label>
    <mat-select formControlName="itemTypeId" (selectionChange)="itemTypeChanged()">
      @for (itemType of data.itemTypes; track itemType.id) {
        <mat-option [value]="itemType.id">{{ itemType.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (isLabour) {
    <mat-form-field appearance="outline">
      <mat-label>{{ "job_upgrade_labour_type" | translate }}</mat-label>
      <mat-select formControlName="labourType">
        @for (labourType of data.labourTypes; track labourType.id) {
          <mat-option [value]="labourType.id">{{ labourType.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  } @else if (selectedType) {
    <mat-form-field appearance="outline">
      <mat-label>{{ "job_upgrade_description_short" | translate }}</mat-label>
      <input matInput formControlName="description">
    </mat-form-field>
  }

  @if (selectedType) {
    <mat-form-field appearance="outline">
      <mat-label>{{ (usesTime ? "job_upgrade_cost_per_hour" : "job_upgrade_unit_price") | translate }}</mat-label>
      <span matTextPrefix>{{ data.currency }}&nbsp;</span>
      <input matInput type="number" min="0.01" step="0.01" formControlName="unitPrice">
    </mat-form-field>

    @if (usesTime) {
      <mat-form-field appearance="outline">
        <mat-label>{{ "job_upgrade_time_spent" | translate }}</mat-label>
        <input matInput type="text" inputmode="numeric" placeholder="00:00" formControlName="timeQuantity">
        <mat-hint>{{ "job_upgrade_time_format" | translate }}</mat-hint>
      </mat-form-field>
    } @else if (usesQuantity) {
      <mat-form-field appearance="outline">
        <mat-label>{{ "job_upgrade_quantity" | translate }}</mat-label>
        <input matInput type="number" min="0.01" step="1" formControlName="quantity">
      </mat-form-field>
    }

    <dl class="line-totals">
      <div><dt>{{ "job_upgrade_tax_rate" | translate: { rate: (data.taxRate * 100 | number: '1.0-2') } }}</dt><dd>{{ data.currency }}{{ tax | number: '1.2-2' }}</dd></div>
      <div><dt>{{ "job_upgrade_total_cost" | translate }}</dt><dd>{{ data.currency }}{{ gross | number: '1.2-2' }}</dd></div>
    </dl>
  }
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-stroked-button type="button" (click)="cancel()">{{ "open_jobs_list_cancel" | translate }}</button>
  <button mat-raised-button type="button" [disabled]="!canSave" (click)="save()">
    <mat-icon>{{ data.lineItem ? 'check' : 'add' }}</mat-icon>{{ (data.lineItem ? "job_upgrade_save_expense" : "job_upgrade_add_expense") | translate }}
  </button>
</mat-dialog-actions>